import { shopsApi } from '@/services/api';

export default {
  addShop: async function (payload) {
    const { data } = await shopsApi.createShop(payload);
    return data;
  },
};
